<div class="not-found-container">
  <div class="not-found text-center">
    <h1 class="mb-3">{{ 'NOT_FOUND' | translate }}</h1>
    <button class="btn btn-lg btn-primary" [routerLink]="['/home']">
      {{ 'GO_TO_HOMEPAGE' | translate }}
    </button>
  </div>
</div>